import DOMPurify from 'dompurify';
import Alert, { type AlertColor, type AlertProps } from '@mui/material/Alert';
import { type SxProps, type Theme } from '@mui/material/styles';
import { Typography } from '@mui/material';
import { type ReactNode } from 'react';
import { type SvgIconComponent } from '@mui/icons-material';

// the standard success alert takes its colors from success.main, too pale to tell it apart from the page
const successSx: SxProps<Theme> = {
  bgcolor: 'success.main',
  color: 'success.dark',
  '& .MuiAlert-icon': { color: 'success.dark' }
};

const getIcon = (Icon?: SvgIconComponent | false) => {
  if (Icon === false) {
    return false;
  }

  if (Icon) {
    return <Icon />;
  }
};

type InfoBannerPropTypes = { Icon?: SvgIconComponent | false; sx?: AlertProps['sx']; action?: AlertProps['action'] } & (
  | { text: string; children?: never; severity?: AlertColor }
  | { text?: never; children: ReactNode; severity?: AlertColor }
);

const InfoBanner = ({ text, children, Icon, severity, sx, action }: InfoBannerPropTypes) => {
  return (
    <Alert
      severity={severity ?? 'info'}
      icon={getIcon(Icon)}
      sx={[severity === 'success' && successSx, ...(Array.isArray(sx) ? sx : [sx])]}
      action={action}
    >
      {text && (
        <Typography
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(text)
          }}
        />
      )}
      {children && children}
    </Alert>
  );
};

export default InfoBanner;
